"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledLinkLabel = exports.StyledLinkIcon = exports.StyledLink = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var _default = {};
exports["default"] = _default;

var StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "Linkstyles__StyledLink",
  componentId: "sc-1y1tigo-0"
})(["", " &:hover{", "}"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    sans-serif inline-flex items-center lh-solid pointer bg-transparent bn\n    ", "\n  "])), function (_ref) {
  var linkType = _ref.linkType,
      types = _ref.theme.link.types;
  return types[linkType]["default"];
}), (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n      ", "\n    "])), function (_ref2) {
  var linkType = _ref2.linkType,
      types = _ref2.theme.link.types;
  return types[linkType].hover;
}));

exports.StyledLink = StyledLink;

var StyledLinkIcon = _styledComponents["default"].span.withConfig({
  displayName: "Linkstyles__StyledLinkIcon",
  componentId: "sc-1y1tigo-1"
})(["", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    f4 pt1\n    ", "\n  "])), function (_ref3) {
  var linkType = _ref3.linkType,
      types = _ref3.theme.link.types;
  return types[linkType].icon.color;
}));

exports.StyledLinkIcon = StyledLinkIcon;

var StyledLinkLabel = _styledComponents["default"].span.withConfig({
  displayName: "Linkstyles__StyledLinkLabel",
  componentId: "sc-1y1tigo-2"
})(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["dib"]))));

exports.StyledLinkLabel = StyledLinkLabel;